module.exports = __webpack_public_path__ + "img/philosophy_manner.81cc6e6e.webp";